import { useAppSelector } from '@store/hooks';
import { selectUsers } from '@store/slices/users/usersSlice';

export const TAB_NAME_TITLES = {
  INFORMATION: 'Information',
  FEATURES: 'Features',
  SERVICES: 'Services',
  SETTINGS: 'Settings',
  CONTACTS: 'Contacts',
  AGREEMENTS: 'Agreements',
  DOCUMENTS: 'Documents',
  ACCESS: 'Access',
  AUDIT_LOGS: 'Audit Logs',
  EXCLUSIONS: 'Exclusions',
  PREFERENCES: 'Preferences',
  BENEFITS: 'Benefits',
  RIDES: 'Rides',
  RIDE_DETAIL: 'Ride Detail',
  LOCATIONS: 'Locations',
  PERMISSIONS: 'Permissions',
  SURVEY_TEMPLATES: 'Survey Templates',
  STANDING_ORDERS: 'Standing Orders',
  STANDING_ORDER_DETAILS: 'Standing Order Details',
  QUALITY_INCIDENTS: 'Quality Incidents',
  MONITORING_BOARD: 'Monitoring Board',
  ASSIGNMENT_BOARD: 'Assignment Board',
  OPERATIONS: 'Operations',
  COMPLIANCE: 'Compliance',
  VEHICLES: 'Vehicles',
  PERSONNEL: 'Personnel',
  CONTRACTOR: 'Contractor',
  HOME: 'Home',
  USERS: 'Users',
  ADMIN: 'Admin',
  PAYER_INVITATIONS: 'Payer Invitations',
  ASSIGNMENT_SCREEN: 'Assignment Screen',
  RIDE_REPORTS: 'Ride Reports',
  MEMBER_REPORTS: 'Member Reports',
  RIDESHARE_REPORTS: 'Rideshare Reports',
  PENDING_RIDES_REPORT: 'Pending Rides Report',
  USER_PROFILE: 'User Profile',
  RECENT_ACTIVITY: 'Recent Activity',
  NOTIFICATIONS: 'Notifications',
} as const;

export const PERMISSION_TITLES = {
  INFO: 'info',
  LOS: 'los',
  SERVICE_TYPE: 'serviceType',
  NOTES: 'notes',
  MODIFICATION_HISTORY: 'modificationHistory',
  RECORD_VIEW_HISTORY: 'recordViewHistory',
  AUTH_CONTACTS: 'authContacts',
  LIMITATIONS: 'limitations',
  SERVICE_AUTHORIZATION: 'serviceAuthorization',
  ELIGIBILITY_TRANSACTIONS: 'eligibilityTransactions',
  RIDE: 'ride',
  STANDING_ORDER: 'standingOrder',
  PENDING_RIDE_REPORT: 'pendingRideReport',
  MONITORING: 'monitoring',
  USERS: 'users',
  PERMISSIONS: 'permissions',
  COVERAGE_AREA: 'coverageArea',
  BUSINESS_HOUR: 'businessHour',
  RIDE_REPORTS: 'rideReports',
  DASHBOARD: 'dashboard',
  AI_INTERACTION_REPORTS: 'aIInteractionReports',
  RIDESHARE_REPORTS: 'rideshareReports',
  MEMBER_REPORTS: 'memberReports',
  FEATURES: 'features',
  SETTINGS: 'settings',
  AGREEMENTS: 'agreements',
  DOCUMENTS: 'documents',
  ACCESS: 'access',
  EXCLUSION: 'exclusion',
  PREFERENCES: 'preferences',
  // contractor portal permissions
  LINKED_PAYERS: 'linkedPayers',
  PENDING_INVITATION: 'pendingInvitations',
  INSURANCE: 'insurance',
  DRIVERS: 'drivers',
  VEHICLES: 'vehicles',
  ASSIGNMENT: 'assignment',
  NOTIFICATIONS: 'notifications',
} as const;

export type AbilityTitleType =
  (typeof PERMISSION_TITLES)[keyof typeof PERMISSION_TITLES];

export const useDefinePermissions = ({
  abilityTitles,
}: {
  abilityTitles: AbilityTitleType[];
}) => {
  const { newPermissions } = useAppSelector(selectUsers);
  // TODO create new logic for permissions
};
